export default {
	data() {
		return {
			loading: false,
			showDialog: false,

			items: [],
			itemsCount: 0,
			scrollOptions: null,

			storeModel: '',
			storeParameter: {},

			dialogEmployee: null,
			dialogItem: null,

			deleteItem: null,
			deleteDialog: false,
		};
	},

	methods: {
		openDialog(info = {}) {
			this.dialogEmployee = null;
			this.dialogItem = null;

			this.showDialog = true;

			if (info.employee) {
				this.dialogEmployee = info.employee;
			}
			if (info.item) {
				this.dialogItem = info.item;
			}
		},

		fetch(options) {
			if (!options) {
				this.$refs.table.resetShownRows();
				options = { page: 1, itemsPerPage: 30 };
				this.items = [];
			}
			this.loading = true;
			return this.$store
				.dispatch(this.storeModel, {
					...this.storeParameter,
					...options,
					// LeaveTypeId: this.vacationTypeId,
					AttendType: this.searchType,
					OrderByCode: this.sort === 1,
					OrderByLate: this.sort ===  2,
					OrderByEarlyLeave: this.sort === 3,
					OrderByOverTime: this.sort === 4,
					Valid: this.notValid ? false : null,
				})
				.then((res) => {
					if ('workDayId' in  this) {
						this.workDayId = res.data ? res.data[0].workDayId : null;
						console.log(this.workDayId)
					}
					console.log(this.workDayId)
					this.itemsCount = res.count;
					// const items =
					// 	res.data.filter(c => this.vacationTypeId ? c.leaveType.id === this.vacationTypeId : true)
					this.items.push(...res.data);
					this.$refs.table.addScrollItems(res.data);
				})
				.catch((e) => {
					e.default && e.default();
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
